export const membershipDiscountFieldTarget = (propertyName) => {
	const fieldMatch = /^inventory_group_discount_(amount|percentage)_(\d+)$/.exec(String(propertyName || ""));
	if (!fieldMatch) {
		return null;
	}

	return {
		field: `discount_${fieldMatch[1]}`,
		index: parseInt(fieldMatch[2], 10),
	};
};

export const updateMembershipDiscountField = (discounts, index, field, value) => (
	(Array.isArray(discounts) ? discounts : []).map((discount, discountIndex) => (
		discountIndex === index
			? {
				...discount,
				[field]: value,
			}
			: discount
	))
);

export const assignMembershipDiscountSortOrder = (discounts) => (
	(Array.isArray(discounts) ? discounts : []).map((discount, sortOrder) => ({
		...discount,
		sort_order: sortOrder,
	}))
);

export const moveMembershipDiscountRow = (discounts, index, direction) => {
	const reorderedDiscounts = [...(Array.isArray(discounts) ? discounts : [])];
	const targetIndex = index + direction;
	if (
		index < 0
		|| index >= reorderedDiscounts.length
		|| targetIndex < 0
		|| targetIndex >= reorderedDiscounts.length
	) {
		return assignMembershipDiscountSortOrder(reorderedDiscounts);
	}

	[reorderedDiscounts[index], reorderedDiscounts[targetIndex]] = [
		reorderedDiscounts[targetIndex],
		reorderedDiscounts[index],
	];

	return assignMembershipDiscountSortOrder(reorderedDiscounts);
};
